import { LayoutDashboard, Building2, Calendar, CheckSquare, Settings } from 'lucide-react';

export const MENTOR_NAV = [
  { path: '/mentor-dashboard', label: 'Overview', icon: LayoutDashboard, end: true },
  { path: '/mentor-dashboard/startups', label: 'Startups', icon: Building2 },
  { path: '/mentor-dashboard/calendar', label: 'Calendar', icon: Calendar },
  { path: '/mentor-dashboard/tasks', label: 'Tasks', icon: CheckSquare },
  { path: '/mentor-dashboard/settings', label: 'Settings', icon: Settings },
];

export const MENTOR_TITLES = {
  '/mentor-dashboard': 'Mentor Overview',
  '/mentor-dashboard/startups': 'Assigned Startups',
  '/mentor-dashboard/calendar': 'Mentor Calendar',
  '/mentor-dashboard/tasks': 'My Tasks & Performance',
  '/mentor-dashboard/settings': 'Mentor Settings',
};
